// import React, { useState } from "react";
// import { useSelector } from "react-redux";
// import {
//   Button,
//   CkTextEditor,
//   Drawer,
//   FormFieldSet,
//   SignatureCard,
// } from "../../../components";

// const MySignature = () => {
//   const [toggle, setToggle] = useState(false);
//   const [createModal, setCreateModal] = useState(false);
//   const [templateTitle, setTemplateTitle] = useState("");
//   const { user } = useSelector((state) => state.auth);
//   const [firstName, setFirstName] = useState(user?.data?.firstName || "");
//   const [lastName, setLastName] = useState(user?.data?.lastName || "");
//   const [phone, setPhone] = useState({
//     code: user?.data?.mobile?.primary?.code || "",
//     number: user?.data?.mobile?.primary?.number || "",
//   });
//   const [email, setEmail] = useState(user?.data?.email?.primary || "");
//   const [role, setRole] = useState(user?.data?.role?.name || "");
//   console.log("First Name:", firstName);
//   console.log("Last Name:", lastName);
//   console.log("Phone:", phone);
//   console.log("Email:", email);
//   console.log("Role:", role);

//   console.log("User Info:", user);
//   return (
//     <div className="flex flex-col flex-1 m-4">
//       <div className="flex justify-between items-center">
//         <div className="flex gap-2 items-center">
//           <FormFieldSet
//             isChecked={toggle}
//             type="toggle"
//             onChange={() => setToggle((prev) => !prev)}
//             noTitle
//             size="sm"
//           />
//           <p className="text-sm">Include Signature in Mail</p>
//         </div>
//         <Button
//           title={"Create New Signature"}
//           size="sm"
//           onClick={() => setCreateModal(true)}
//         />
//       </div>
//       <div className="grid grid-cols-3 gap-4 my-3">
//         {Array.from({ length: 8 }, (_, i) => (
//           <SignatureCard style={`Style ${i + 1}`} />
//         ))}
//       </div>
//       <Drawer
//         isOpen={createModal}
//         title={"Add Signature"}
//         onClose={() => setCreateModal(false)}
//         width="w-[50%]"
//       >
//         <div className="my-6 flex flex-col gap-4">
//           <FormFieldSet
//             title="Template Title"
//             placeholder="Template Title"
//             value={templateTitle}
//             onChange={(val) => setTemplateTitle(val)}
//           />
//           <CkTextEditor />
//           <div className="flex justify-end gap-3">
//             <Button
//               size="sm"
//               variant="outlined"
//               title={"Cancel"}
//               onClick={() => setCreateModal(false)}
//             />
//             <Button size="sm" title={"Save"} />
//           </div>
//         </div>
//       </Drawer>
//     </div>
//   );
// };

// export default MySignature;

// import React, { useState, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   Button,
//   CkTextEditor,
//   Drawer,
//   FormFieldSet,
//   SignatureCard,
// } from "../../../components";
// import {
//   addSignatureStart,
//   getSignaturesStart,
// } from "../../../redux/slices/signatures/signaturesSlice";

// const MySignature = () => {
//   const dispatch = useDispatch();
//   const { user } = useSelector((state) => state.auth);

//   const [toggle, setToggle] = useState(false);
//   const [createModal, setCreateModal] = useState(false);
//   const [templateTitle, setTemplateTitle] = useState("");

//   // User details already stored in state
//   const [firstName] = useState(user?.data?.firstName || "");
//   const [lastName] = useState(user?.data?.lastName || "");
//   const [designation] = useState(user?.data?.designation || "");
//   const [email] = useState(user?.data?.email?.primary || "");
//   const [phone] = useState({
//     code: user?.data?.mobile?.primary?.code || "",
//     number: user?.data?.mobile?.primary?.number || "",
//   });
//   const [role] = useState(user?.data?.role?.name || "");
//   const { signatures } = useSelector((state) => state.signatures);

//   const handleSave = () => {
//     const address = {
//       country: user?.data?.address?.country || "",
//       state: user?.data?.address?.state || "",
//       city: user?.data?.address?.city || "",
//     };

//     const payload = {
//       coll: "Signature",
//       payload: {
//         templateName: templateTitle,
//         firstName: user?.data?.firstName || "",
//         lastName: user?.data?.lastName || "",
//         designation: user?.data?.designation || "",
//         email: user?.data?.email?.primary || "",

//         mobileNumber: {
//           code: user?.data?.mobile?.primary?.code || "",
//           number: user?.data?.mobile?.primary?.number || "",
//         },
//         addedBy: user?.data?.uiid,
//         address,
//       },
//     };

//     console.log("Final Payload Before Dispatch:", payload);
//     dispatch(addSignatureStart(payload));
//     fetchSignatures();
//     setCreateModal(false);
//   };

//   const fetchSignatures = () => {
//     const action = {
//       coll: "Signature",
//       fil: JSON.stringify({
//         addedBy: { type: "NONE", value: user?.data?.uiid },
//       }),
//       lim: 50,
//     };

//     dispatch(getSignaturesStart(action));
//   };

//   useEffect(() => {
//     fetchSignatures();
//   }, []);

//   return (
//     <div className="flex flex-col flex-1 m-4">
//       {/* Header with toggle and create button */}
//       <div className="flex justify-between items-center">
//         <div className="flex gap-2 items-center">
//           <FormFieldSet
//             isChecked={toggle}
//             type="toggle"
//             onChange={() => setToggle((prev) => !prev)}
//             noTitle
//             size="sm"
//           />
//           <p className="text-sm">Include Signature in Mail</p>
//         </div>
//         <Button
//           title={"Create New Signature"}
//           size="sm"
//           onClick={() => setCreateModal(true)}
//         />
//       </div>

//       <div className="grid grid-cols-3 gap-4 my-3">
//         {signatures?.data?.map((sig) => {
//           const address = sig.address
//             ? [sig.address.city, sig.address.state, sig.address.country]
//                 .filter(Boolean) // removes undefined or null
//                 .join(", ")
//             : "—";
//           return (
//             <SignatureCard
//               key={sig._id}
//               style={sig.templateName}
//               name={`${sig.firstName} ${sig.lastName}`}
//               phone={`${sig.mobileNumber?.code || ""} ${
//                 sig.mobileNumber?.number || ""
//               }`}
//               email={sig.email}
//               address={address} // now it's "City, State, Country"
//               uiid={sig.uiid}
//               designation={sig.designation}
//             />
//           );
//         })}
//       </div>

//       {/* Drawer for creating signature */}
//       <Drawer
//         isOpen={createModal}
//         title={"Add Signature"}
//         onClose={() => setCreateModal(false)}
//         width="w-[50%]"
//       >
//         <div className="my-6 flex flex-col gap-4">
//           {/* Only Template Title input */}
//           <FormFieldSet
//             title="Template Title"
//             placeholder="Template Title"
//             value={templateTitle}
//             onChange={(val) => setTemplateTitle(val)}
//           />

//           <CkTextEditor />

//           <div className="flex justify-end gap-3">
//             <Button
//               size="sm"
//               variant="outlined"
//               title={"Cancel"}
//               onClick={() => setCreateModal(false)}
//             />
//             <Button size="sm" title={"Save"} onClick={handleSave} />
//           </div>
//         </div>
//       </Drawer>
//     </div>
//   );
// };

// export default MySignature;

import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Backdrop,
  Button,
  CkTextEditor,
  Drawer,
  FormFieldSet,
  LogoLoader,
  SignatureCard,
} from "../../../components";
import {
  addSignatureStart,
  getSignaturesStart,
} from "../../../redux/slices/signatures/signaturesSlice";
import { formatWords2 } from "../../../utils/stringUtils";

const MySignature = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { signatures } = useSelector((state) => state.signatures);

  // Toggle for signature in mail
  const [toggle, setToggle] = useState(false);

  // Drawer control for create signature
  const [createModal, setCreateModal] = useState(false);

  // Template title input
  const [templateTitle, setTemplateTitle] = useState("");

  // Template content input
  const [templateContent, setTemplateContent] = useState("");

  const [loading, setloading] = useState(false);

  // Fetch signatures for current user
  const fetchSignatures = () => {
    if (!user?.data?.uiid) return;

    setloading(true);
    const action = {
      coll: "Signature",
      fil: JSON.stringify({
        addedBy: { type: "NONE", value: user?.data?.uiid },
      }),
      lim: 50,
    };
    dispatch(getSignaturesStart(action));
    setloading(false);
  };

  useEffect(() => {
    fetchSignatures();
  }, [user]);

  // Handle create signature
  const handleSave = () => {
    if (!templateTitle) return alert("Please enter template title");

    const address = {
      country: user?.data?.address?.country || "",
      state: user?.data?.address?.state || "",
      city: user?.data?.address?.city || "",
    };

    const payload = {
      coll: "Signature",
      payload: {
        templateName: templateTitle,
        firstName: user?.data?.firstName || "",
        lastName: user?.data?.lastName || "",
        designation: user?.data?.designation || "",
        email: {
          email: user?.data?.email?.primary || "",
        },
        mobileNumber: {
          code: user?.data?.mobile?.primary?.code || "+91",
          number: user?.data?.mobile?.primary?.number || "",
        },
        addedBy: user?.data?.uiid,
        address,
        website: user?.data?.organizationId?.website
      },
    };

    console.log("Payload before dispatch:", payload);
    dispatch(addSignatureStart(payload));

    // Refresh list after creation
    // fetchSignatures();
    setCreateModal(false);
    setTemplateTitle("");
  };

  return (
    <div className="flex flex-col flex-1 m-4">
      {/* Header with toggle and create button */}
      <div className="flex justify-between items-center mb-4">
        <div className="flex gap-2 items-center">
          <FormFieldSet
            isChecked={toggle}
            type="toggle"
            onChange={() => setToggle((prev) => !prev)}
            noTitle
            size="sm"
          />
          <p className="text-sm">Include Signature in Mail</p>
        </div>
        <Button
          title="Create New Signature"
          size="sm"
          onClick={() => setCreateModal(true)}
        />
      </div>

      {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {signatures?.data?.length > 0 ? (
          signatures.data.map((sig) => {
            const address = sig.address
              ? [sig.address.city, sig.address.state, sig.address.country]
                  .filter(Boolean)
                  .join(", ")
              : "—";

            const mobile = sig.mobileNumber
              ? `${sig.mobileNumber.code || ""} ${
                  sig.mobileNumber.number || ""
                }`
              : "";

            return (
              <SignatureCard
                key={sig._id}
                style={sig.templateName}
                name={`${sig.firstName} ${sig.lastName}`}
                designation={sig.designation}
                phone={mobile}
                email={sig.email}
                address={address}
                uiid={sig.uiid}
              />
            );
          })
        ) : (
          <p className="col-span-full text-gray-500 text-sm">
            No signatures found. Create a new one.
          </p>
        )}
      </div> */}
      <div className="grid 2xl:grid-cols-3 md:grid-cols-2 lg:grid-cols-2 gap-4">
        {/* {signatures?.data?.length > 0 ? (
          signatures.data.map((sig) => {
            // Format address as "City, State, Country"
            const address = sig.address
              ? [sig.address.city, sig.address.state, sig.address.country]
                  .filter(Boolean)
                  .join(", ")
              : "—";

            // Real mobile number from API
            const mobile = sig.mobileNumber
              ? `${sig.mobileNumber.code || ""} ${
                  sig.mobileNumber.number || ""
                }`
              : "—";

            // Dummy placeholders
            const phone = "Phone: +91 9876565445";
            const web = "Web: yue@yu.in";

            return (
              <SignatureCard
                key={sig._id}
                style={sig.templateName}
                name={`${sig.firstName} ${sig.lastName}`}
                designation={sig.designation}
                // phone={phone}
                mobile={mobile}
                email={sig.email}
                web={web}
                address={address}
                uiid={sig.uiid}
              />
            );
          })
        ) : (
          <p className="col-span-full text-gray-500 text-sm">
            No signatures found. Create a new one.
          </p>
        )} */}
        {signatures?.data?.length > 0 ? (
          signatures?.data?.map((sig) => {
            const address = sig?.address ? [sig?.address?.city, sig?.address?.state, sig?.address?.country].filter(Boolean).join(", ") : "—";
            const mobile = sig?.mobileNumber ? `${sig?.mobileNumber?.code || ""} ${sig?.mobileNumber?.number || ""}` : "—";
            const website = sig?.website || "";
            const email = typeof sig?.email == "object" ? sig?.email?.email : sig?.email

            return (
              <SignatureCard
                key={sig?._id}
                style={sig?.templateName}
                name={`${formatWords2(sig?.firstName || "")} ${formatWords2(sig?.lastName || "")}`}
                designation={sig?.designation}
                mobile={mobile}
                email={email}
                website={website}
                address={address}
                uiid={sig?.uiid}
              />
            );
          })
        ) : (
          <p className="col-span-full text-gray-500 text-sm">
            No signatures found. Create a new one.
          </p>
        )}
      </div>

      {/* Drawer for creating signature */}
      <Drawer
        isOpen={createModal}
        title="Add Signature"
        onClose={() => setCreateModal(false)}
        width="w-[50%]"
      >
        <div className="my-6 flex flex-col gap-4">
          {/* Template Title input */}
          <FormFieldSet
            title="Template Title"
            placeholder="Template Title"
            value={templateTitle}
            onChange={(val) => setTemplateTitle(val)}
          />

          {/* CKEditor for content */}
          <CkTextEditor value={templateContent} onChange={(value) => setTemplateContent(value)} />

          <div className="flex justify-end gap-3">
            <Button
              size="sm"
              variant="outlined"
              title="Cancel"
              onClick={() => setCreateModal(false)}
            />
            <Button size="sm" title="Save" onClick={handleSave} />
          </div>
        </div>
      </Drawer>

      <Backdrop isOpen={loading} zIndex={54}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default MySignature;
